// index.js or main file
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import UserRules from './pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import ThankYou from './pages/thankyou/thankyou';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';
import ThemeUpdate from './admin/pages/themeupdate/themeupdate';
import MainAme from './pages/maingame/maingame';
import CopySession from './pages/copySession/copySession';

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const path = location.pathname;
    /** Routes that set their own full-viewport theme image — skip index.css `common-bg` (img/background.jpg) to avoid double layers */
    const ownBackdrop =
      /^\/game\/?$/i.test(path) ||
      /^\/leaderboard\/?$/i.test(path) ||
      /^\/maingame\/?$/i.test(path);
    if (path.startsWith("/admin")) {
      body.classList.remove("common-bg");
    } else if (ownBackdrop) {
      body.classList.remove("common-bg");
    } else {
      body.classList.add("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
        {/* Explicit paths (most specific first) so /admin always = theme admin, never the superadmin login */}
        <Route path="/admin/superadmin" element={<LoginPage />} />
        <Route path="/admin/rules" element={<Admin><Rules /></Admin>} />
        <Route path="/admin/themeupdate" element={<Admin><ThemeUpdate /></Admin>} />
        <Route path="/admin" element={<Admin><Home /></Admin>} />

        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules />} />
              <Route path="/welcome" element={<Navigate to="/game" replace />} />
              <Route path="/maingame" element={<MainAme />} />
              <Route path="/sortandtoss" element={<Navigate to="/welcome" replace />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/CopySession" element={<CopySession />} />
              <Route path="/thankyou" element={<ThankYou />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
